<script lang="ts">
import type { DailySpinProgress } from '@/types'
import { type PropType, defineComponent } from 'vue'

import WeeklyProgress from '../common/WeeklyProgress.vue'

/**
 * DailyGameCard
 */
export default defineComponent({
  components: {
    WeeklyProgress,
  },
  props: {
    progress: {
      type: Object as PropType<DailySpinProgress[]>,
      required: true,
    },
  },
  methods: {
    async redirectToDailySpins() {
      await this.$router.push({ name: 'daily-spins' })
    },
  },
})
</script>

<template>
  <div
    class="daily-game-card flex flex-col gap-2 rounded-lg p-3 border border-[#B6C6CF]"
  >
    <p class="flex gap-2 font-semibold">
      <AppIcon :icon="Icons.CalendarStar" /> Spin & Win Daily Game
    </p>

    <WeeklyProgress class="my-1" :progress />

    <AppRegisterSignInModal id="daily-game-signup-signin-modal">
      <template v-if="$userStore.isLoggedOut" #button="{ openModal }">
        <AppTextButton
          :variant="UI.TextButton.Variant.Secondary"
          label="Play For Free"
          @click="openModal('register', redirectToDailySpins)"
        />
      </template>
    </AppRegisterSignInModal>

    <AppTextButton
      v-if="$userStore.isLoggedIn"
      :variant="UI.TextButton.Variant.Secondary"
      label="Play For Free"
      :route="{ name: 'daily-spins' }"
    />
  </div>
</template>
